const ACTIONS = {
    CHANGED_SELECTED_DATES: 'DATE_PICKER/CHANGED',
    SUBMIT_SELECTED_DATES: 'DATE_PICKER/SUBMIT',
    DISABLED_DAY_CLICK_ATTEMPT: 'DATE_PICKER/DISABLED_DAY_CLICK_ATTEMPT',
    DATE_INPUT_FOCUS: 'DATE_PICKER/DATE_INPUT_FOCUS',
    UPDATE_DATE_PICKER_STATE: 'DATE_PICKER/UPDATE_DATE_PICKER_STATE',
    REMOUNT_DATE_PICKER: 'DATE_PICKER/REMOUNT'
};

const ACTION_CREATORS = {
    changedSelectedDates(fieldsChanged) {
        return {
            type: ACTIONS.CHANGED_SELECTED_DATES,
            payload: {fieldsChanged}
        };
    },
    // The external react-availability-date-picker updates start/end dates via action/reducer
    //      where the built in date-range-picker does do by a callback passed as a prop.  The
    //      usePayload bool is to tell the reducer to use those dates pass vs those already
    //      updated in the reducer via callback.
    // TRAVOPS-906 will clean some of this up.
    submitSelectedDates(startDate, endDate, usePayload = false) {
        return {
            type: ACTIONS.SUBMIT_SELECTED_DATES,
            payload: {
                startDate,
                endDate,
                usePayload
            }
        };
    },
    disabledDayClickAttempt(date) {
        return {
            type: ACTIONS.DISABLED_DAY_CLICK_ATTEMPT,
            payload: {date}
        };
    },
    dateInputFocus(isCheckout) {
        return {
            type: ACTIONS.DATE_INPUT_FOCUS,
            payload: {selectingCheckout: isCheckout}
        };
    },
    updateDatePickerState(
        datePickerStates = {
            datePickerPrevState: 'CLOSED',
            datePickerState: 'CLOSED'
        }
    ) {
        return {
            type: ACTIONS.UPDATE_DATE_PICKER_STATE,
            payload: {
                datePickerPrevState: datePickerStates.datePickerPrevState,
                datePickerState: datePickerStates.datePickerState
            }
        };
    },
    remountDatePicker() {
        return {
            type: ACTIONS.REMOUNT_DATE_PICKER
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
